import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Integrations = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [connecting, setConnecting] = useState(false);
  const [toast, setToast] = useState(null);

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 4000);
  };

  const authHeaders = { headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` } };

  const fetchStatus = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/api/instagram/status', authHeaders);
      setAccounts(res.data.accounts || []);
    } catch (err) {
      console.error(err);
      showToast('Bağlantı durumu kontrol edilemedi', 'error');
    }
    setLoading(false);
  };

  useEffect(() => {
    // OAuth callback bizi buraya ?instagram_connected=1/0&error=... ile geri
    // yönlendiriyor - URL'i temizleyip kullanıcıya sonucu toast olarak gösteriyoruz.
    const params = new URLSearchParams(window.location.search);
    const connected = params.get('instagram_connected');
    if (connected === '1') {
      showToast('Instagram hesabınız başarıyla bağlandı!', 'success');
    } else if (connected === '0') {
      showToast(params.get('error') || 'Instagram bağlantısı başarısız oldu', 'error');
    }
    if (connected !== null) {
      window.history.replaceState({}, '', window.location.pathname);
    }

    fetchStatus();
  }, []);

  const handleConnect = async () => {
    setConnecting(true);
    try {
      const res = await axios.post('/api/instagram/oauth/init', {}, authHeaders);
      window.location.href = res.data.redirect_url;
    } catch (err) {
      console.error(err);
      showToast('Bağlantı başlatılamadı', 'error');
      setConnecting(false);
    }
  };

  const handleDisconnect = async (accountId) => {
    if (!window.confirm('Bu Instagram bağlantısını kaldırmak istediğinize emin misiniz? DM otomasyonu bu hesap için duracaktır.')) return;
    setLoading(true);
    try {
      await axios.delete(`/api/instagram/disconnect/${accountId}`, authHeaders);
      showToast('Instagram bağlantısı kaldırıldı', 'success');
      fetchStatus();
    } catch (err) {
      console.error(err);
      showToast('Hata oluştu', 'error');
      setLoading(false);
    }
  };

  const connectedAccounts = accounts.filter(a => a.connected);
  // "connected: false" burada iki farklı şeyi anlatabilir: hiç bağlanmamış (accounts
  // boş) veya DAHA ÖNCE bağlıydı ama token yenilemesi/geçerliliği başarısız olup
  // otomatik koptu (satır hâlâ var, sadece is_active=0). İkincisi kritik - işletme
  // haftalarca Instagram DM'lerine hiç AI cevabı gitmediğini fark etmeden bu ekrana
  // baksa bile eskiden "hiç bağlanmamış" ile birebir aynı görünüyordu. Artık ayrı
  // gösteriliyor ki bir kopma sessizce geçmesin.
  const disconnectedAccounts = accounts.filter(a => !a.connected);

  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
      {toast && (
        <div className={`integrations-toast ${toast.type}`}>
          {toast.message}
        </div>
      )}

      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 'bold', margin: '0 0 4px 0', color: 'var(--text)' }}>
          🔌 Entegrasyonlar
        </h1>
        <p style={{ margin: 0, color: 'var(--text-muted)' }}>Sosyal medya hesaplarınızı bağlayarak DM otomasyonunu aktif edin</p>
      </div>

      <div className="card" style={{ maxWidth: '600px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
          <div style={{ width: '56px', height: '56px', borderRadius: '16px', background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '26px', flexShrink: 0 }}>
            📷
          </div>
          <div>
            <h3 style={{ margin: '0 0 2px 0', color: 'var(--text)' }}>Instagram</h3>
            <p style={{ margin: 0, fontSize: '13px', color: 'var(--text-muted)' }}>Gelen Instagram DM'lerine otomatik AI yanıtı — birden fazla hesap bağlayabilirsiniz</p>
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '24px', color: 'var(--text-muted)' }}>Yükleniyor...</div>
        ) : (
          <>
            {disconnectedAccounts.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '16px' }}>
                {disconnectedAccounts.map(acc => (
                  <div key={acc.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', padding: '10px 14px', borderRadius: '10px', background: 'rgba(239,68,68,0.08)', border: '1px solid #EF4444' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                      <span className="badge" style={{ padding: '6px 12px', gap: '8px', flexShrink: 0, background: '#EF4444', color: 'white' }}>
                        <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'white' }}></span>
                        Bağlantı Kesildi
                      </span>
                      <span style={{ fontSize: '13px', color: 'var(--text)', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {acc.label || `Hesap ${acc.id}`}
                      </span>
                    </div>
                    <button className="btn btn-primary" style={{ flexShrink: 0 }} onClick={handleConnect} disabled={connecting}>Yeniden Bağlan</button>
                  </div>
                ))}
                <p style={{ fontSize: '12px', color: '#EF4444', margin: 0 }}>
                  ⚠️ Bu hesap(lar) için Instagram DM otomasyonu durdu — gelen mesajlara AI yanıtı üretilemiyor. Yeniden bağlanana kadar müşteriler cevap alamaz.
                </p>
              </div>
            )}

            {connectedAccounts.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '16px' }}>
                {connectedAccounts.map(acc => (
                  <div key={acc.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', padding: '10px 14px', borderRadius: '10px', background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                      <span className="badge badge-success" style={{ padding: '6px 12px', gap: '8px', flexShrink: 0 }}>
                        <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#10b981' }}></span>
                        Bağlı
                      </span>
                      <span style={{ fontSize: '13px', color: 'var(--text)', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {acc.label || `Hesap ${acc.id}`}
                      </span>
                      <span style={{ fontSize: '12px', color: 'var(--text-muted)', flexShrink: 0 }}>ID: {acc.instagram_account_id}</span>
                    </div>
                    <button className="btn btn-secondary" style={{ flexShrink: 0 }} onClick={() => handleDisconnect(acc.id)}>Kaldır</button>
                  </div>
                ))}
              </div>
            )}

            {accounts.length === 0 && (
              <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '16px' }}>
                Kendi Instagram işletme hesabınızla giriş yapıp yetkilendirdiğinizde,
                gelen mesajlar otomatik olarak bu CRM'e düşmeye başlar.
              </p>
            )}

            {/* 2. hesap ekleme özelliği şimdilik kapatıldı - bir şubede birden fazla
                legacy Instagram hesabı olması, her hesabın kendi Meta App app_secret'ı
                taşıyabilmesi yüzünden webhook imza doğrulamasında bir hataya yol açmıştı
                (bkz. /webhook/instagram/:branchId imza kontrolü). O hata ayrıca düzeltildi,
                ama "ilk hesap zaten bağlıyken ikinciyi eklemeyi" UI'dan kaldırıyoruz - hiçbir
                şubede şu an 2. hesap yok, tekrar açılana kadar tek hesapla devam ediliyor. */}
            {connectedAccounts.length === 0 && (
              <button className="btn btn-primary" onClick={handleConnect} disabled={connecting}>
                {connecting ? 'Yönlendiriliyor...' : '📷 Instagram ile Bağlan'}
              </button>
            )}
          </>
        )}
      </div>

      <style>{`
        .integrations-toast {
          position: fixed; bottom: 24px; right: 24px; z-index: 9999;
          padding: 14px 20px; border-radius: 12px; font-size: 14px; font-weight: 600;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
          animation: toastIn 0.3s ease;
        }
        .integrations-toast.success { background: #10B981; color: white; }
        .integrations-toast.error { background: #EF4444; color: white; }
        @keyframes toastIn { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }
      `}</style>
    </div>
  );
};

export default Integrations;
